<template>
    <div class="admin-page">
        <h2 class="page-title">Admin - <span class="fw-semi-bold">Pannel</span></h2>
        <b-row>
            <b-col xs="12">
                <Widget
                        title="<h5>Admin <span class='fw-semi-bold'>Permission Table</span></h5>"
                        bodyClass="widget-table-overflow"
                        customHeader>
                    <p style="margin-left: 1%">The table describes the <code> permission </code> of the admin</p>
                    <div class="table-responsive">
                        <table class="table table-lg mb-0 requests-table table-hover">
                            <thead>
                            <tr class="text-muted">
                                <th><span class="fw-bold">ID</span></th>
                                <th><span class="fw-bold">Name</span></th>
                                <th><span class="fw-bold">Photo</span></th>
                                <th><span class="fw-bold">Phone</span></th>
                                <th><span class="fw-bold">Permissions</span></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                    v-for="row in mock.table"
                                    :key="row.id"
                            >
                                <td>{{row.id}}</td>
                                <td>{{row.name}}</td>
                                <td>
                                    <img class="rounded-circle" :src="row.picture" alt="" height="50" />
                                </td>
                                <td>{{row.phone}}</td>
                                <td>
                                    <b-badge v-for="per in row.permissions" :key="per.name" :variant="(per.status)? 'success' : 'danger'" class="ml-1">{{per.name}}</b-badge>
                                </td>
                                <!--<td>
                                    <b-button @click="setSelectedAgent(row)"
                                              :variant="row.status === 'Add'? 'success' : 'danger'"
                                              class="p-1 px-3 btn-xs">
                                        {{row.status}}
                                    </b-button>
                                </td>-->
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </Widget>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Widget from '@/components/admin/Widget/Widget';
    import mock from "./adminmock";

    export default {
        name: 'AdminPannel',
        components: {
            Widget
        },
        data() {
            return {
                mock
            };
        },
        methods: {
            setSelectedAgent(a){
                a.workStatus=!a.workStatus;
                if(a.status==='Add') a.status='Remove';
                else a.status='Add';
            }
        },
    };
</script>
<style src="./AdminPannel.scss" lang="scss" />
